import classnames from 'classnames';
import { connect } from 'react-redux';

import { VODCSSModules } from 'shared/utils/wix-connect';

import { areElementsRounded } from 'shared/selectors/app-settings';

import { GenericButton } from 'shared/components/button/button';

import styles from './button.styl';


@connect(state => ({
  isRounded: areElementsRounded(state),
}))
@VODCSSModules(styles)
export default class Button extends React.Component {

  static propTypes = {
    isRounded: React.PropTypes.bool,
    disableRoundBorders: React.PropTypes.bool,
    disableTheme: React.PropTypes.bool,
  };

  static defaultProps = {
    disableRoundBorders: false,
    disableTheme: false,
  };

  render() {
    const { isRounded, disableRoundBorders, disableTheme } = this.props;
    const props = _.omit(this.props, 'isRounded', 'styles', 'dispatch', 'disableRoundBorders', 'disableTheme');

    const styleNames = classnames('button', {
      'disable-theme': disableTheme,
      rounded: !disableRoundBorders && isRounded,
    });

    return (
      <GenericButton {...props}
                     styleName={styleNames} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/button/button.js